import { Controller } from "@hotwired/stimulus"

export default class CurrentTimeController extends Controller {
    static targets = ['currentDate', 'currentTime', 'timeInput', 'dateInput']

    declare hasCurrentDateTarget: boolean
    declare hasCurrentTimeTarget: boolean
    declare hasDateInputTarget: boolean
    declare hasTimeInputTarget: boolean
    declare currentDateTarget: HTMLElement
    declare currentTimeTarget: HTMLElement
    declare dateInputTarget: HTMLInputElement
    declare timeInputTarget: HTMLInputElement
    declare timer: ReturnType<typeof setInterval>

    connect() {
        this.startTimer();
        this.updateTime();
    }

    disconnect() {
        this.stopTimer();
    }

    setDate() {
        this.setCurrent()
    }

    setTime() {
        this.setCurrent()
    }

    setCurrent() {
        if (this.hasDateInputTarget && this.hasCurrentDateTarget) {
            this.dateInputTarget.value = this.currentDateTarget.textContent || ''
        }
        if (this.hasTimeInputTarget && this.hasCurrentTimeTarget) {
            const s = this.currentTimeTarget.textContent || ''
            this.timeInputTarget.value = s.substring(0, s.length - 1);
        }
    }

    startTimer() {
        this.timer = setInterval(() => {
            this.updateTime();
        }, 1000)
    }

    stopTimer() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }

    updateTime(): void {
        const now = new Date()
        const hours = now.getUTCHours().toString().padStart(2, '0')
        const minutes = now.getUTCMinutes().toString().padStart(2, '0')
        const day = now.getUTCDate().toString().padStart(2, '0')
        const month = (new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDay(), 0, 0, 0, 0)).toLocaleDateString('en-US', {month: 'short'})
        const year = now.getUTCFullYear()

        if (this.hasCurrentTimeTarget) {
            this.currentTimeTarget.textContent = `${hours}:${minutes}Z`
        }
        if (this.hasCurrentDateTarget) {
            this.currentDateTarget.textContent = `${day} ${month} ${year}`
        }
    }
}